import { render, staticRenderFns } from "./AgeGate.vue?vue&type=template&id=3ac18c97&"
import script from "./AgeGate.vue?vue&type=script&lang=js&"
export * from "./AgeGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports